// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"25d80104","453":"a3c1d153","455":"ccc58e57","977":"249ef776"}[chunkId] + ".chunk.js";
};